import { OptimizelyExperiments, useOptimizelyExperiment } from 'lib/optimizely/optimizelyUtils'

const DestinationExperiments = {
  anywhere: OptimizelyExperiments.searchLowMpvHidingAnywhere,
  bali: OptimizelyExperiments.searchLowMpvHidingBali,
  thailand: OptimizelyExperiments.searchLowMpvHidingThailand,
  fiji: OptimizelyExperiments.searchLowMpvHidingFiji,
}

export default function useSearchLowMpvHidingExperiment(destination?: string): number {
  const experiment = destination && DestinationExperiments[destination.toLowerCase()]
  return useOptimizelyExperiment(experiment, !!experiment)
}
